import { asset } from './asset';
import NavigationHeader from './NavigationHeader';
import { useTranslation } from 'react-i18next';

function HeroSection() {
  const { t } = useTranslation();
  return (
    <section id="home" className="relative overflow-hidden bg-white text-white mx-auto sm:max-w-[80%] max-w-[90%] px-6 pb-20 pt-32 sm:px-8 lg:px-12 lg:pb-28 lg:pt-40">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-55"
        style={{ backgroundImage: `url(${asset('image3.png')})` }}
      />
      <div className="absolute inset-0" />
      <div className="relative z-10">
        <NavigationHeader />

        <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-white">
          {t('hero.eyebrow')} <span className="px-2">&middot;</span>
        </p>

        <div className="mt-8 max-w-4xl">
          <h1 className="text-5xl font-black leading-tight sm:text-6xl">
            {t('hero.title_line1')}
            <br />
            {t('hero.title_line2')}
          </h1>
          <p className="mt-7 max-w-3xl text-lg font-semibold leading-8 text-slate-200 lg:text-xl">
            {t('hero.body')}
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <a
              href="#system"
              className="rounded bg-emerald-500 px-6 py-3 text-sm font-extrabold uppercase text-[#071018] transition hover:bg-emerald-400"
            >
              {t('hero.cta_system')}
            </a>
            <a
              href="#compliance"
              className="rounded border border-white/25 px-6 py-3 text-sm font-extrabold uppercase text-white transition hover:border-emerald-400 hover:text-emerald-400"
            >
              {t('hero.cta_compliance')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
